import React, { useContext } from 'react';
import loadable from '@loadable/component';
import { SpinLoader } from '@qover/molecules';
import { LocaleContext } from '@qover/contexts';
import type { PolicyholderProps } from './Policyholder';

const PolicyholderBe = loadable(() => import('./be/Policyholder'), {
  fallback: <SpinLoader />,
});

const PolicyholderFr = loadable(() => import('./fr/Policyholder'), {
  fallback: <SpinLoader />,
});

const PolicyholderNl = loadable(() => import('./nl/Policyholder'), {
  fallback: <SpinLoader />,
});

const PolicyholderDe = loadable(() => import('./de/Policyholder'), {
  fallback: <SpinLoader />,
});

const PolicyholderGb = loadable(() => import('./gb/Policyholder'), {
  fallback: <SpinLoader />,
});

const PolicyholderIt = loadable(() => import('./it/Policyholder'), {
  fallback: <SpinLoader />,
});

const PolicyholderEs = loadable(() => import('./es/Policyholder'), {
  fallback: <SpinLoader />,
});

const PolicyholderPt = loadable(() => import('./pt/Policyholder'), {
  fallback: <SpinLoader />,
});

const PolicyholderIe = loadable(() => import('./ie/Policyholder'), {
  fallback: <SpinLoader />,
});

const PolicyholderAt = loadable(() => import('./at/Policyholder'), {
  fallback: <SpinLoader />,
});

const PolicyholderPl = loadable(() => import('./pl/Policyholder'), {
  fallback: <SpinLoader />,
});

export const Policyholder: React.FC<PolicyholderProps> = props => {
  const { country } = useContext(LocaleContext);

  return (
    <>
      {country === 'AT' && <PolicyholderAt {...props} />}
      {country === 'BE' && <PolicyholderBe {...props} />}
      {country === 'DE' && <PolicyholderDe {...props} />}
      {country === 'ES' && <PolicyholderEs {...props} />}
      {country === 'FR' && <PolicyholderFr {...props} />}
      {country === 'GB' && <PolicyholderGb {...props} />}
      {country === 'IE' && <PolicyholderIe {...props} />}
      {country === 'IT' && <PolicyholderIt {...props} />}
      {country === 'NL' && <PolicyholderNl {...props} />}
      {country === 'PL' && <PolicyholderPl {...props} />}
      {country === 'PT' && <PolicyholderPt {...props} />}
    </>
  );
};
